import { useQuery } from "@apollo/client";

import AutomationApplication from "@components/automations/AutomationApplication";
import HandleQuery from "@components/HandleQuery";
import ExpertPage from "@components/pageTypes/ExpertPage";
import {
  GetAutomationApplicationDocument,
  GetAutomationApplicationQuery,
  GetAutomationApplicationQueryVariables
} from "@typing/Generated";

type Props = {
  automationApplicationId: string;
  automationId: string;
};

const ExpertAutomationApplicationPage = ({ automationApplicationId }: Props) => {
  const getAutomationApplicationQuery = useQuery<GetAutomationApplicationQuery, GetAutomationApplicationQueryVariables>(
    GetAutomationApplicationDocument,
    {
      variables: {
        id: automationApplicationId
      }
    }
  );

  return (
    <ExpertPage
      helmetKey="pageTitles.expert.automationApplication.show"
      imageName="map"
      titleKey="pages.expert.automationApplication.title"
    >
      <HandleQuery query={getAutomationApplicationQuery}>
        {data => <AutomationApplication automationApplication={data.automationApplication} />}
      </HandleQuery>
    </ExpertPage>
  );
};

export default ExpertAutomationApplicationPage;
